import React, { useState, useEffect } from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import '../../sass/components/flexibleModules/_components.customerStoryModule.scss';
import Slider from "react-slick";
import "../../sass/slick/slick.min.scss"
import "../../sass/slick/slick-theme.min.scss"

const CustomerStoryModule = ({ data }) => {

    const [isRendered, setIsRendered] = useState(false)
    const [numberSlide, setNumberSlide] = useState(2);

    let settings = {
        dots: false,
        infinite: true,
        autoplay: false,
        cssEase: 'linear',
        arrows: true,
        speed: 500,
        slidesToShow: numberSlide,
        slidesToScroll: 1,
        draggable: true,
        centerMode: false,
        swipeToSlide: true,
        touchThreshold: 250,
        responsive: [
            {
                breakpoint: 850,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };
    useEffect(() => {
        {
            data.layoutSelection === 'layout2' ?
                setNumberSlide(1)
                :
                setNumberSlide(2)
        }
        setIsRendered(true);
    }, [numberSlide]);

    return (
        <div className={`cp-customerStoryModule ${data.layoutSelection}`} style={{ backgroundColor: `${data.backgroundColor ? data.backgroundColor : ""}` }}>
            <div className="cp-customerStoryModule__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {data.customerStoriesCarouselMainHeader &&
                    <h2>{data.customerStoriesCarouselMainHeader}</h2>
                }
                {data.customerStoriesCarouselSections &&
                    <div className="cp-customerStoryCarousel">
                        {isRendered && (
                            <Slider {...settings}>
                                {data.customerStoriesCarouselSections.map((storyItem, index) => (
                                    <div className="cp-customerStoryCarousel__section" key={index}>
                                        {storyItem.logo &&
                                            <img src={storyItem.logo.sourceUrl} alt={storyItem.logo.altText} />
                                        }
                                        {storyItem.teaser &&
                                            <p dangerouslySetInnerHTML={{ __html: storyItem.teaser }} />
                                        }
                                        <div className="cp-customerStoryCarousel__section-author l--flex">
                                            {storyItem.customerName &&
                                                <span>{storyItem.customerName},</span>
                                            }
                                            {storyItem.customerTitle &&
                                                <span>{storyItem.customerTitle}</span>
                                            }
                                        </div>
                                        {storyItem.customerStoryLink &&
                                            <>
                                                {storyItem.customerStoryLink.url.substr(-1) !== '/' ?
                                                    <a href={`${storyItem.customerStoryLink.url+'/'}`} target={storyItem.customerStoryLink.target} className="l-button" dangerouslySetInnerHTML={{ __html: storyItem.customerStoryLink.title }} />
                                                    :
                                                    <a href={storyItem.customerStoryLink.url} target={storyItem.customerStoryLink.target} className="l-button" dangerouslySetInnerHTML={{ __html: storyItem.customerStoryLink.title }} />
                                                }
                                            </>
                                        }
                                    </div>
                                ))}
                            </Slider>
                        )}
                    </div>
                }
            </div>
        </div>
    );
}

export default CustomerStoryModule;